import { render, staticRenderFns } from "./FormGraphicalPDFSubfield.vue?vue&type=template&id=54d0f5cc&scoped=true&"
import script from "./FormGraphicalPDFSubfield.vue?vue&type=script&lang=ts&"
export * from "./FormGraphicalPDFSubfield.vue?vue&type=script&lang=ts&"
import style0 from "./FormGraphicalPDFSubfield.vue?vue&type=style&index=0&id=54d0f5cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d0f5cc",
  null
  
)

export default component.exports